import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay/classic';
import { Link, withRouter } from 'react-router';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import classNames from 'classnames';
import _ from 'underscore';
import moment from 'moment';
import Dialog from 'components/widgets/Dialog';
import { ZInput } from 'components/widgets/ZElements';
import DatePicker from 'components/widgets/DatePicker';
import { handleChange , DateTimeFormat} from 'components/helpers/utils';
import UpdateProfileMutation from 'mutations/UpdateProfileMutation';
import ChangePinMutation from 'mutations/ChangePinMutation';
import ChangeEmailMutation from 'mutations/ChangeEmailMutation';
import ResendEmailVerificationMutation from 'mutations/ResendEmailVerificationMutation';

import 'react-datetime/css/react-datetime.css';
import '../styles/profile.less';

class Profile extends React.Component {
  static propTypes = {
    viewer: PropTypes.shape({
      zapperId: PropTypes.string,
      auth: PropTypes.shape({
        id: PropTypes.string,
        mobile: PropTypes.string,
        email: PropTypes.string,
        isEmailConfirmed: PropTypes.bool
      }),
      profile: PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        birthday: PropTypes.string,
        gender: PropTypes.string,
        streetAddress: PropTypes.string,
        locationId: PropTypes.string
      }),
      country: PropTypes.shape({
        codeAlpha2: PropTypes.string,
        locationId: PropTypes.string,
        defaultLocationId: PropTypes.string,
        name: PropTypes.string,
        regions: PropTypes.arrayOf(
          PropTypes.shape({
            locationId: PropTypes.string,
            name: PropTypes.string,
            cities: PropTypes.arrayOf(
              PropTypes.shape({
                locationId: PropTypes.string,
                name: PropTypes.string
              })
            )
          })
        )
      })
    }).isRequired,
    children: PropTypes.bool
  };

  constructor(props) {
    super(props);
    const { viewer: { profile, country } } = this.props;
    this.state = {
      gender: profile ? profile.gender : profile,
      location: profile ? profile.locationId : country.defaultLocationId,
      birthday: profile
        ? profile.birthday ? moment(profile.birthday, 'YYYY-MM-DD') : null
        : null,
      showEmailDialog: false,
      showCompleteRegDialog: true,

      savingProfileChanges: false,
      successSavingProfileChanges: false,
      profileSubmitted: false,

      savingPinChanges: false,

      pinError: null,

      pinSubmitted: false,
      pinButtonText: 'Save',

      emailError: null,

      resendButtonText: 'Resend',
      resendEmailErrCode: null,
      oldPin: '',
      newPin: '',
      confirmPin: ''
    };
    this.handleChange = handleChange.bind(this);
    this.onGenderChanged = this.onGenderChanged.bind(this);
    this.onRegionChanged = this.onRegionChanged.bind(this);
    this.handleProfileSubmit = this.handleProfileSubmit.bind(this);
    this.handlePinSubmit = this.handlePinSubmit.bind(this);
    this.handleEditEmailSubmit = this.handleEditEmailSubmit.bind(this);
    this.resendEmailVerification = this.resendEmailVerification.bind(this);
    this.hideEmailDialog = this.hideEmailDialog.bind(this);
    this.showEmailDialog = this.showEmailDialog.bind(this);
  }

  componentWillMount() {
    const { viewer, router } = this.props;
    let zapperId = viewer ? viewer.zapperId : null;
    if (!zapperId) {
      router.replace('/login');
    }

    let profile = this.props.viewer.profile;
    let country = this.props.viewer.country;
    let regions = country.regions;

    let location = profile.locationId
      ? profile.locationId
      : country.defaultLocationId;

    regions.forEach(v => {
      if (location === v.locationId) {
        this.setState({ region: v, location: v.locationId });
        return;
      }
      v.cities.forEach(vv => {
        if (location === vv.locationId) {
          this.setState({ region: v, location: vv.locationId });
          return;
        }
      });
    });
  }

  /*
    onChange handlers
  */
  onGenderChanged(e) {
    this.handleChange(e, value => value.toUpperCase());
  }
  onRegionChanged(e) {
    let regions = this.props.viewer.country.regions;
    let region = regions.find(function(r) {
      return r.locationId === e.target.value;
    });
    this.setState({ location: e.target.value });
    this.setState({ region });
  }

  onBirthdayChange(e) {
    this.setState({ birthday: e });
  }
  onEditEmailSuccess() {
    this.hideEmailDialog();
  }

  onEditEmailFailure(e) {
    let str = JSON.stringify(e.getError());
    let response = JSON.parse(str);
    let errArr = response.source.errors;

    let errorObj = _.first(errArr);

    if (errorObj && errorObj.error) {
      this.setState({ emailError: {code: errorObj.error.code, errorType: errorObj.error.type, data: errorObj.error.data} });
    } else {
      this.setState({ emailError: {code: 500} });
    }
  }

  onSuccess() {
    this.setState({
      savingProfileChanges: false,
      successSavingProfileChanges: true
    });

    setTimeout(() => {
      this.setState({ successSavingProfileChanges: false });
    }, 3000);
  }
  onFailure() {
    this.setState({
      savingProfileChanges: false,
      successSavingProfileChanges: false
    });
  }

  onProfileSubmitClicked = () => {
    this.setState({ profileSubmitted: true });
  };

  onNewPinSubmitClicked = () => {
    this.setState({ pinSubmitted: true });
  };

  onPinSuccess() {
    this.resetPinForm();
    this.setState({
      savingPinChanges: false,
      pinError: null,
      pinButtonText: 'PIN Saved',
      pinSubmitted: false
    });
    setTimeout(() => {
      this.setState({ pinButtonText: 'Save' });
    }, 3000);
  }

  onPinFailure(e) {
    let str = JSON.stringify(e.getError());
    let response = JSON.parse(str);
    let errArr = response.source.errors;

    let errorObj = _.first(errArr);

    if (errorObj && errorObj.error) {
      let errCode = errorObj.error.code;
      this.setPinErrorCode({code: errCode, errorType: errorObj.error.type, data: errorObj.error.data});
    } else {
      this.setPinErrorCode({code: 500});
    }
  }

  setPinErrorCode(errJson) {
    this.setState({
      savingPinChanges: false,
      pinError: errJson,
      pinButtonText: 'Save',
      pinSubmitted: false
    });
  }

  getPinErrorMessage(jsonErr) {
    let pinErrorMessage = '';
    if(jsonErr.errorType && jsonErr.errorType == 'InvalidPin') {
      let triesLeft = jsonErr.data && jsonErr.data.attemptsLeft ? jsonErr.data.attemptsLeft + ' tries left.' : '';
      pinErrorMessage = 'Invalid PIN. ' + triesLeft;
    } else if (jsonErr.errorType && jsonErr.errorType == 'AccountLocked') {
      let formattedDate = jsonErr.data && jsonErr.data.lockedUntil ? ' after ' + DateTimeFormat(jsonErr.data.lockedUntil) : '';
      pinErrorMessage = 'Account is locked. Please try again' + formattedDate + '.';
    }
    return pinErrorMessage;
  }

  /*
    Form Submission
  */
  handleProfileSubmit(e) {
    e.preventDefault();
    let refs = this.refs;
    let address = refs.address.value;

    let profile = {
      id: this.props.viewer.profile.id,
      firstName: refs.firstName.value,
      lastName: refs.lastName.value,
      birthday: this.state.birthday
        ? this.state.birthday.format('YYYY-MM-DD')
        : null,
      gender: this.state.gender,
      locationId: this.state.location
    };
    if (address) {
      profile.address = address;
    }

    let onSuccess = () => {
      this.onSuccess();
    };
    let onFailure = () => {
      this.onFailure();
    };

    this.setState({ savingProfileChanges: true });
    let mutation = new UpdateProfileMutation({ profile: profile });
    Relay.Store.commitUpdate(mutation, { onSuccess, onFailure });
  }

  requiredFormFieldClassNames(submitted) {
    return classNames('form-field', {
      submitted: submitted
    });
  }

  handlePinSubmit(e) {
    e.preventDefault();
    let changePin = {
      zapperId: this.props.viewer.zapperId,
      oldPin: this.state.oldPin,
      newPin: this.state.newPin
    };

    let onSuccess = () => {
      this.onPinSuccess();
    };
    let onFailure = e => {
      this.onPinFailure(e);
    };
    this.setState({ savingPinChanges: true, pinButtonText: 'Saving' });
    let mutation = new ChangePinMutation(changePin);
    Relay.Store.commitUpdate(mutation, { onSuccess, onFailure });
  }

  resetPinForm() {
    this.setState({
      newPin: '',
      confirmPin: '',
      oldPin: ''
    });
    this.refs.newPin.resetToPristine();
    this.refs.confirmPin.resetToPristine();
    this.refs.oldPin.resetToPristine();
  }

  handleEditEmailSubmit(e) {
    e.preventDefault();
    let email = e.target[1].value;
    let pin = e.target[2].value;

    let onSuccess = () => {
      this.onEditEmailSuccess();
    };
    let onFailure = e => {
      this.onEditEmailFailure(e);
    };

    let mutation = new ChangeEmailMutation({
      id: this.props.viewer.auth.id,
      email: email,
      pin: pin
    });
    Relay.Store.commitUpdate(mutation, { onSuccess, onFailure });
  }

  showEmailDialog() {
    this.setState({ showEmailDialog: true });
  }

  hideEmailDialog() {
    this.setState({ showEmailDialog: false, emailError: null });
  }

  resendEmailVerification() {
    let onSuccess = () => {
      this.setState({ resendButtonText: 'Sent' });
      setTimeout(() => {
        this.setState({ resendButtonText: 'Resend' });
      }, 3000);
    };

    let onFailure = e => {
      let str = JSON.stringify(e.getError());
      let response = JSON.parse(str);
      let errArr = response.source.errors;

      let errorObj = _.first(errArr);

      if (errorObj && errorObj.error) {
        this.setState({ resendEmailErrCode: errorObj.error.code });
      } else {
        this.setState({ resendEmailErrCode: 500 });
      }
    };

    let mutation = new ResendEmailVerificationMutation();
    Relay.Store.commitUpdate(mutation, { onSuccess, onFailure });
  }

  hideErrDialog = () => {
    this.setState({ resendEmailErrCode: null });
  };

  hideCompleteRegPopUp = () => {
    this.setState({ showCompleteRegDialog: false });
  };

  isCompleteProfile() {
    let viewer = this.props.viewer;
    let profile = viewer.profile;
    let auth = viewer.auth;

    if (
      auth.email &&
      profile.firstName &&
      profile.lastName &&
      profile.birthday &&
      profile.gender &&
      profile.locationId
    ) {
      return true;
    }
    return false;
  }

  /*
    Base Containers
  */
  renderProfileBaseContainer = () => {
    let submitButtonClassNames = classNames('button', {
      saving: this.state.savingProfileChanges
    });
    let enableFieldset = this.state.savingProfileChanges ? 'disabled' : '';

    let submitButtonText;
    if (this.state.savingProfileChanges) {
      submitButtonText = 'Saving';
    } else if (
      !this.state.savingProfileChanges &&
      this.state.successSavingProfileChanges
    ) {
      submitButtonText = 'Changes Saved';
    } else {
      submitButtonText = 'Save';
    }

    return (
      <div className="profile-container">
        <form className="form" onSubmit={this.handleProfileSubmit}>
          <fieldset disabled={enableFieldset}>
            {this.renderLeftContainer()}
            {this.renderRightContainer()}
            <div className="button-container">
              <input
                className={submitButtonClassNames}
                type="submit"
                value={submitButtonText}
                onClick={this.onProfileSubmitClicked}
              />
            </div>
          </fieldset>
        </form>
      </div>
    );
  };
  renderPinBaseContainer() {
    let submitButtonClassNames = classNames('button', {
      saving: this.state.savingPinChanges
    });

    let enableFieldset = this.state.savingPinChanges ? 'disabled' : '';
    return (
      <div className="change-pin-container">
        <form
          className="form"
          onSubmit={this.handlePinSubmit}
          autoComplete="off"
        >
          <fieldset disabled={enableFieldset}>
            {this.renderNewPinContainer()}
            <div className="button-container">
              <input
                className={submitButtonClassNames}
                type="submit"
                value={this.state.pinButtonText}
                onClick={this.onNewPinSubmitClicked}
              />
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
  renderBorder(title) {
    return (
      <div className="section-border">
        <div className="section-title">{title}</div>
      </div>
    );
  }

  /*
    Child Containers
  */
  renderNewPinContainer() {
    return <div className="new-pin-form">{this.renderPinElements()}</div>;
  }

  renderPinElements = () => {
    let refs = this.refs;
    if (refs.confirmPin && this.state.newPin !== this.state.confirmPin) {
      refs.confirmPin.passCustomValidity('Pin must match');
    } else if (refs.confirmPin) {
      refs.confirmPin.passCustomValidity('');
    }

    let cond = this.state.pinError;

    let pinErrorMessage = cond ? this.getPinErrorMessage(cond) : '';

    let formatError = 'PIN must be exactly 6 digits';
    let fields = [
      {
        name: 'oldPin',
        label: 'Current PIN',
        ref: 'oldPin',
        errorMsg: formatError,
        customErrMsg:
          cond && cond.code === 401
            ? pinErrorMessage
            : ''
      },
      {
        name: 'newPin',
        label: 'New PIN',
        ref: 'newPin',
        errorMsg: formatError,
        customErrMsg:
          cond && cond === 400
            ? 'PIN has invalid format. Please try again.'
            : ''
      },
      {
        name: 'confirmPin',
        label: 'Confirm New PIN',
        ref: 'confirmPin',
        errorMsg: 'Please enter the same PIN as above',
        customErrMsg:
          cond && cond === 500 ? 'Unable to change PIN. Please try again.' : ''
      }
    ];

    return fields.map(field => (
      <div className="form-field" key={field.ref}>
        <label>{field.label}</label>
        <ZInput
          name={field.name}
          ref={field.ref}
          onChange={this.handleChange}
          value={this.state[field.name]}
          label={field.label}
          password
          type="tel"
          pattern="\d{6}"
          maxLength="6"
          error={field.errorMsg}
          customError={field.customErrMsg}
          required
          errorMessageVisible
        />
      </div>
    ));
  };

  renderLeftContainer = () => {
    let profile = this.props.viewer.profile;
    let auth = this.props.viewer.auth;
    let mobileNumber = auth.mobile;
    let email = auth.email;
    let isEmailConfirmed = auth.isEmailConfirmed;
    let codeAlpha2 = this.props.viewer.country.codeAlpha2;
    const phoneUtil = PhoneNumberUtil.getInstance();

    mobileNumber = '+' + mobileNumber;

    const phoneNumber = phoneUtil.parse(mobileNumber, '');
    const cc = phoneUtil.getRegionCodeForNumber(phoneNumber);

    if (cc === codeAlpha2) {
      let nationalNumber = phoneNumber.getNationalNumber().toString();

      if (!nationalNumber.startsWith('9')) {
        mobileNumber = '0' + nationalNumber;

        mobileNumber = mobileNumber.replace(
          /(\d{4})(\d{3})(\d{4})/,
          '$1 $2 $3'
        );
      } else {
        mobileNumber = phoneUtil.format(
          phoneNumber,
          PhoneNumberFormat.NATIONAL
        );
      }
    } else {
      mobileNumber = phoneUtil.format(
        phoneNumber,
        PhoneNumberFormat.INTERNATIONAL
      );
    }

    let confirmElement;
    if (!isEmailConfirmed) {
      let resendElement = this.renderResendElement();
      confirmElement = (
        <div className="confirm">
          E-mail address is not yet verified. Click the link in your
          verification e-mail.
          {resendElement}
        </div>
      );
    }

    let emailElement;
    if (email) {
      emailElement = (
        <div className="email-container">
          <div className="email" title={email}>
            {email}
          </div>
          <a className="edit email-add" onClick={this.showEmailDialog}>
            Edit
          </a>
        </div>
      );
    } else {
      emailElement = (
        <input
          className="form-input"
          onFocus={this.showEmailDialog}
          value={email}
        />
      );
    }

    let requiredFormFieldClassNames = this.requiredFormFieldClassNames(
      this.state.profileSubmitted
    );

    return (
      <div className="left-form">
        <div className="form-field">
          <label>Mobile Number</label>
          <div className="mobile-number-container">
            <div className="mobile-number">{mobileNumber}</div>
            <Link className="edit mobile" to="/contact">
              Contact Zap to Change
            </Link>
          </div>
        </div>
        <div className="form-field">
          <label>Email Address</label>
          {emailElement}
        </div>
        {confirmElement}

        <div className={requiredFormFieldClassNames}>
          <label>First Name</label>
          <input
            className="form-input"
            type="text"
            ref="firstName"
            defaultValue={profile.firstName}
            title="First name is required"
            required
          />  
        </div>

        <div className={requiredFormFieldClassNames}>
          <label>Last Name</label>
          <input
            className="form-input"
            type="text"
            ref="lastName"
            defaultValue={profile.lastName}
            title="Last name is required"
            required
          />
        </div>

        <div className="form-field">
          <label>Address</label>
          <input
            className="form-input"
            type="text"
            ref="address"
            defaultValue={profile.streetAddress}
          />
        </div>
      </div>
    );
  };

  renderRightContainer = () => {
    let profile = this.props.viewer.profile;
    let gender = profile.gender ? profile.gender.toLowerCase() : '';

    let requiredFormFieldClassNames = this.requiredFormFieldClassNames(
      this.state.profileSubmitted
    );
    let regions = this.props.viewer.country.regions;
    let cities = this.state.region ? this.state.region.cities : null;

    return (
      <div className="right-form">
        <div className={requiredFormFieldClassNames}>
          <label>Date of Birth</label>
          <DatePicker
            name="birthday"
            value={this.state.birthday ? this.state.birthday : null}
            onChange={e => this.onBirthdayChange(e)}
          />
        </div>

        <div className={requiredFormFieldClassNames}>
          <label>Gender</label>
          <select
            name="gender"
            className="gender"
            onChange={this.onGenderChanged}
            defaultValue={gender}
            title="Gender is required"
            required
          >
            <option value="" disabled>
              Gender
            </option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>

        <div className={requiredFormFieldClassNames}>
          <label>Region</label>
          {this.renderRegionSelectField(profile, regions)}
        </div>

        {this.state.region && this.state.region.cities.length > 0 ? (
          <div className={requiredFormFieldClassNames}>
            <label>City</label>
            {this.renderCitySelectField(profile, cities)}
          </div>
        ) : null}
      </div>
    );
  };

  renderRegionSelectField(profile, regions) {
    regions.sort((a, b) => {
      if (a.name > b.name) return 1;
      if (a.name < b.name) return -1;
      return 0;
    });
    let regionId = this.state.region ? this.state.region.locationId : '';

    return (
      <select
        className="location"
        name="location"
        onChange={this.onRegionChanged}
        defaultValue={regionId}
        title="Region is required"
        required
      >
        <option value="" disabled>
          Select a location
        </option>
        {regions.map(function(region, i) {
          return (
            <option key={i} value={region.locationId}>
              {region.name}
            </option>
          );
        })}
      </select>
    );
  }

  renderCitySelectField(profile, cities) {
    cities.sort((a, b) => {
      if (a.name > b.name) return 1;
      if (a.name < b.name) return -1;
      return 0;
    });

    let city = this.state.location ? this.state.location : '';

    return (
      <select
        className="location"
        name="location"
        onChange={this.handleChange}
        defaultValue={city}
        title="City is required"
        required
      >
        <option value="" disabled>
          Select a location
        </option>
        {cities.map(function(city, i) {
          return (
            <option key={i} value={city.locationId}>
              {city.name}
            </option>
          );
        })}
      </select>
    );
  }

  renderResendElement() {
    let condition = this.state.resendButtonText === 'Resend';
    let resendElementClassName = classNames('edit', 'resend', {
      'resend-clickable': condition
    });
    let onResendClickFunc = condition ? this.resendEmailVerification : () => {};
    return (
      <a className={resendElementClassName} onClick={onResendClickFunc}>
        {this.state.resendButtonText}
      </a>
    );
  }

  render() {
    let zapperId = this.props.viewer ? this.props.viewer.zapperId : null;
    let auth = this.props.viewer ? this.props.viewer.auth : null;

    if (zapperId) {
      let dialog;
      if (this.state.showEmailDialog) {

        let pinErrorMessage = this.state.emailError ? this.getPinErrorMessage(this.state.emailError) : '';

        let errCode = this.state.emailError ? this.state.emailError.code : 0;

        let pinErr = errCode === 401 ? pinErrorMessage : '';
        pinErr =
          errCode === 500 ? 'Unable to change email at this time' : pinErr;
        let emailErr = errCode === 409 ? 'Email already in use' : '';

        dialog = (
          <Dialog
            type="update-email"
            email={auth.email}
            pinErr={pinErr}
            emailErr={emailErr}
            handleEditEmailSubmit={this.handleEditEmailSubmit}
            handleExit={this.hideEmailDialog}
          />
        );
      }
      if (!this.isCompleteProfile() && this.state.showCompleteRegDialog) {
        dialog = (
          <Dialog type="complete-reg" handleExit={this.hideCompleteRegPopUp} />
        );
      }

      if (this.state.resendEmailErrCode) {
        let message;
        switch (this.state.resendEmailErrCode) {
          case 403:
            message = 'Resend Count Exceeded';
            break;
          case 404:
            message = 'Email Verification Expired';
            break;
          default:
            //handles 500 and others
            message = 'Unable to Resend. Please try again later.';
            break;
        }

        dialog = (
          <Dialog
            type="error"
            handleExit={this.hideErrDialog}
            errTitle="Resend Verification Email Failed"
            errMessage={message}
          />
        );
      }

      return (
        <div id="profile">
          {this.renderBorder('Personal Information')}
          {this.renderProfileBaseContainer()}

          {this.renderBorder('Change Pin')}
          {this.renderPinBaseContainer()}
          {dialog}
        </div>
      );
    }
    return <div />;
  }
}

export default Relay.createContainer(withRouter(Profile), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        zapperId,
        auth {
          id,
          mobile,
          email,
          isEmailConfirmed,
        },
        profile {
          id,
          firstName,
          lastName,
          birthday,
          gender,
          streetAddress,
          locationId
        },
        country {
          locationId,
          defaultLocationId,
          codeAlpha2,
          name,
          regions {
            locationId,
            name,
            cities {
              locationId,
              name
            }
          }
        }
      }`
  }
});



// WEBPACK FOOTER //
// ./js/components/pages/Profile.js